import type { FaireProductEntity } from "../../entity_types/product";

export const p_s7mmax23bu: FaireProductEntity = {
  token: "p_s7mmax23bu",
  type: "product",
  name: "Judy Hall's Complete Crystal Workshop",
  brandToken: "b_elwnrzazbf",
  brandName: "Microcosm Publishing & Distribution",
  imageUrl:
    "https://cdn.faire.com/fastly/ce9b37de2edaf72889cb4c593244fb5b9292c9dab21d0965c4e5ecc2a4eba6f0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dded1b5b48c9d93661d98bc880c4fc1d383cece3c494b08a4acf42299b68763c.png",
  ],
  priceDollars: 11.78,
  description:
    "Author Judy Hall is a bonafide crystal expert and in this complete crystal workshop she proffers some of the thought-provoking wisdom that crystal exploration has given her. Much more than a reference guide, more even than a personal tutor, approaching something close to a best friend and mentor, Judy Hall's Complete Crystal Workshop gives you all the key concepts of using crystals. You'll be inspired by these holistic, interactive exercises that tailor the book to your exact wants and needs. Whether you are an experienced crystal veteran on someone just getting your crystal feet wet, so to speak, this book is for you.(This book may contain a sharpie mark on the top or bottom edge and may show mild signs of shelfwear.)",
  tags: [],
  msrpDollars: 23.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:21.538Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
